import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '../../base/ui/components/web/Dialog';
import { allowVoiceAgent, declineVoiceAgent } from '../actions';
/**
 * Asks whether a voice agent may hear the local participant (which also makes the agent audible and
 * visible to them). Cannot be dismissed without a decision, like the recording consent dialog.
 *
 * @param {IProps} props - The props.
 * @returns {JSX.Element}
 */
export default function VoiceAgentConsentDialog({ agentId, forcedMute }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const agent = useSelector((state) => state['features/voice-agents'].agents[agentId]);
    const consentLearnMoreLink = useSelector((state) => state['features/base/config'].voiceAgents?.consentLearnMoreLink);
    const name = agent?.displayName ?? agentId;
    useEffect(() => {
        APP.API.notifyVoiceAgentConsentDialogOpen(true, agentId);
        return () => {
            APP.API.notifyVoiceAgentConsentDialogOpen(false, agentId);
        };
    }, [agentId]);
    const allow = useCallback(() => {
        dispatch(allowVoiceAgent(agentId));
    }, [agentId]);
    const decline = useCallback(() => {
        dispatch(declineVoiceAgent(agentId));
    }, [agentId]);
    return (React.createElement(Dialog, { cancel: { translationKey: 'voiceAgents.notNow' }, disableBackdropClose: true, disableEscape: true, hideCloseButton: true, ok: { translationKey: 'voiceAgents.allow' }, onCancel: decline, onSubmit: allow, title: t('voiceAgents.consentTitle', { name }) },
        t(forcedMute ? 'voiceAgents.consentDescriptionMuted' : 'voiceAgents.consentDescription'),
        consentLearnMoreLink && (React.createElement(React.Fragment, null,
            ' ',
            React.createElement("a", { href: consentLearnMoreLink, rel: 'noopener noreferrer', target: '_blank' }, t('dialog.learnMore')),
            '.'))));
}
